import { PageSharedModule } from './../../../../shared/page-shared/page-shared.module';
import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { LeafletMarkerModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-marker/leaflet-marker.module';
import { LeafletCircleMarkerModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-circle-marker/leaflet-circle-marker.module';
import { LeafletArcModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-arc/leaflet-arc.module';
import { LeafletTileLayerModule } from './../../../widgets/leaflet-map/leaflet-blocks/leaflet-tile-layer/leaflet-tile-layer.module';
import { LeafletMapModule } from './../../../widgets/leaflet-map/leaflet-map.module';
import { DxAutocompleteModule, DxPopupModule, DxDataGridModule, DxButtonModule, DxDropDownButtonModule, DxScrollViewModule, DxPopoverModule, DxNumberBoxModule, DxSelectBoxModule } from 'devextreme-angular';
import { FiltersGroupModule } from './../../../widgets/filters/filters-group/filters-group.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NetworkDeepDiveMapRoutingModule } from './network-deep-dive-map-routing.module';
import { NetworkDeepDiveMapComponent } from './network-deep-dive-map/network-deep-dive-map.component';
import { DirectivesModule } from 'src/app/directives/directives/directives.module';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';

@NgModule({
	declarations: [NetworkDeepDiveMapComponent],
	imports: [
		CommonModule,
		PageSharedModule,
		NetworkDeepDiveMapRoutingModule,

		DirectivesModule,

		FiltersGroupModule,
		HelpButtonComponent,
		JumpToModule,

		LeafletMapModule,
		LeafletTileLayerModule,
		LeafletArcModule,
		LeafletCircleMarkerModule,
		LeafletMarkerModule,

		DxAutocompleteModule,
		DxPopupModule,
		DxNumberBoxModule,
		DxSelectBoxModule,
		DxPopoverModule,
		DxDataGridModule,
		DxButtonModule,
		DxDropDownButtonModule,
		DxScrollViewModule,
	]
})
export class NetworkDeepDiveMapModule { }
